module.exports = __webpack_public_path__ + "img/ico-total-cotizaciones.0ad62c5f.svg";